import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
// utils
import {Translations} from '../../utils';
// restClient
import {aemHostClient} from '../../restClient';
//action Creator
import {setDarkTitleBarContent} from '../layouts/actions/actionCreator';
//style
import './index.css';

class Welcome extends Component{

  constructor(props) {
    super(props);
    this.state = {
      welcomeCase : {},
      supportDoc :{},
      isSupportDoc : true,
      owningCaseUrn: this.props.history.location.state.Urn
    };
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount(){
    aemHostClient("/aemData/formData/json_intro")
    .then(({data, status}) => {
      this.setState({welcomeCase: data});
    });
    aemHostClient("/aemData/formData/json_supporting-docs")
    .then(({data, status}) => {
      this.setState({supportDoc: data});
    });

    aemHostClient("/aemData/formData/json_dark-title-bar")
    .then(({data, status}) => {
         document.title = `${this.translations(data.par.static_text_darkTitleBar.welcome)} - ${'HSBC GLCM'}`
          this.props.setDarkTitleBarContent(this.translations(data.par.static_text_darkTitleBar.welcome));
    });
  }
  _eventHandlerWelcome = () => {
    let _state = this.state;
    _state['isSupportDoc'] = false;
    this.setState(_state);
    this.props.history.push({
      pathname: `/case-body/supporting-doc/${this.state.owningCaseUrn}`,
      state: { Urn:this.state.owningCaseUrn  }
    });
  }
  _eventHandleGoToCase = () => {

  }

  render(){

    const welcomeCase = (data)  => {
      if(data.par !== undefined){
        const { button_nextSupportingDocs,info_graphic_checkDetails ,info_graphic_generateDocumentation,info_graphic_inviteOthers} = data.par;
        return(
          <div className="gdoc-welcome-container">
          <ul>
          <li>
          <div className="gdoc-welcome-checkdetails">
          <span>1</span>
          <div className="gdoc-welcome-checkdetails-content">
          <h2 className="heading">{this.translations(info_graphic_checkDetails.title)}</h2>
          <p>{this.translations(info_graphic_checkDetails.text)}</p>
          </div>
          </div>
          </li>
          <li>
          <div className="gdoc-welcome-generateDocumentation">
          <span>2</span>
          <div className="gdoc-welcome-generateDocumentation-content">
          <h2 className="heading">{this.translations(info_graphic_generateDocumentation.title)}</h2>
          <p>{this.translations(info_graphic_generateDocumentation.text)}</p>
          </div>
          </div>
          </li>
          <li>
          <div className="gdoc-welcome-inviteOthers">
          <span>3</span>
          <div className="gdoc-welcome-inviteOthers-content">
          <h2 className="heading">{this.translations(info_graphic_inviteOthers.title)}</h2>
          <p>{this.translations(info_graphic_inviteOthers.text)}</p> </div>
          </div>
          <input type="button" onClick={()=>this._eventHandlerWelcome()} name="supportingDoc" value={this.translations(button_nextSupportingDocs.text)} />
          </li>
          </ul>
          </div>
        );
      }else{
        return null;
      }
    }

    // const supportingDoc = (data) => {
    //   if(data.par !== undefined){
    //     const { button_goToCase,page_title_mainTitle ,static_text_supportDocs} = data.par;
    //
    //     return (<div className="gdoc-welcome-containersupportdoc">
    //     <div className="gdoc-welcome-subcontainersupportdoc">
    //     <div className="heading">{page_title_mainTitle.pageHeading}</div>
    //     <div className="gdoc-welcome-supportdoc">
    //     <span className="gdoc-welcome-subheading">{static_text_supportDocs.text}</span>
    //     <ul>
    //     <li>
    //     <span>Country of Incorporation - UK - Customer authorisation</span>
    //     </li>
    //     <li>
    //     <span>Canada - Form W-9</span>
    //     </li>
    //     <li>
    //     <span>Australia - Certificate of legal validity</span>
    //     </li>
    //     <li>
    //     <span>[Other doc]</span>
    //     </li>
    //     <li>
    //     <span>[Other doc]</span>
    //     </li>
    //     </ul>
    //     <span className="gdoc-welcome-subheading2">You can see more details on these anytime in the 'Supporting docs' section accessed from the case menu</span>
    //     </div>
    //     <div className="gdoc-welcome-btn">
    //     <input type="button" onClick={()=>this._eventHandleGoToCase()} name={button_goToCase.name} value={button_goToCase.text} />
    //     </div>
    //     </div>
    //     </div>);
    //   }else{
    //     return null;
    //   }
    // }

    const finalContent =  welcomeCase(this.state.welcomeCase)
    return finalContent;

  }
}

Welcome.defaultProps = {

}
Welcome.propTypes = {
  pageJson : PropTypes.object,
  supportDoc :  PropTypes.object,
};

const mapStateToProps = (state, props) => {
  return {
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/components/Welcome/index.js